import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";
import Table from "../../../../../../components/Table";
import BaseListPage from "../../../../../../base/BaseListPage";
import ScheduleTablePresenter from "./ScheduleTablePresenter";
import schedule from "../../../../../ReferenceTable/schedule-template/schedule/shdedule-form/schedule-page/scheduleSchema.json";
import { formatDate } from "../../../../../../components/common/Converter";
import SearchSelect from "../../../../../../components/searchSelect/SearchSelect";

export default class ScheduleTable extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ScheduleTablePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      scheduleTemplate: [],
      selectedSchedule: props?.object?.selectedSchedule || "",
      object: [],
      deletedArray: [],
      objects: [],
      count: 0,
      limit: 20,
      current: 1,
    };
  }

  getCollectionName() {
    return "schedule_template";
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const schedules = await findObjectUseCase().execute(
      this.getCollectionName(),
      {
        where: { status: "active" },
      },
    );
    this.setState({
      scheduleTemplate: schedules,
      // selectedSchedule: this.props.object.selectedSchedule,
    });
  }

  getCurrent() {
    return this.state.selectedSchedule || "";
  }

  // delete function
  // async handleDeleteData(id) {
  //   const filter = this.props.object.schedule.filter((item) => item.id !== id);

  //   console.log("filterrr", filter);
  //   this.props.schedObj(filter);
  // }
  async refetchData() {
    // const selectedSchedule = this.props.object.selectedSchedule;
    // const schedule = await findObjectUseCase().execute("schedule");
    // const object = schedule.filter((data) => data.name === selectedSchedule);
    // this.setState({ object });
  }

  async handleScheduleChange(selectedSchedule) {
    this.setState({
      selectedSchedule: selectedSchedule,
      // scheduleArray: selectedSchedule.scheduleArray,
    });
    this.props.scheduleChange?.(selectedSchedule);
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = schedule;
    const { scheduleTemplate, current, count, limit, selectedSchedule } =
      this.state;
    // }

    // console.log("selectedSchedule: ", selectedSchedule);
    return (
      <>
        <div className="m-4">
          <div
            className="col-lg-8 p-1 mb-4 d-flex justify-content-between align-items-center"
            style={{}}
          >
            <div className="w-50">
              <SearchSelect
                value={selectedSchedule?.name}
                disabled={this.props.disabled}
                onClickClear={() => {
                  this.handleScheduleChange(null);
                }}
                focus={true}
                onChange={this.handleScheduleChange.bind(this)}
                options={scheduleTemplate.map((sched) => {
                  return {
                    label: sched.name,
                    value: sched
                      ? {
                          name: sched.name,
                          id: sched.id,
                          scheduleArray: sched.scheduleArray,
                          startingDate: sched.startingDate,
                          selectedOption: sched.selectedOption,
                          sequence: sched.sequence,
                        }
                      : null,
                  };
                })}
              />
            </div>

            {selectedSchedule?.startingDate && (
              <label>
                Start Date: <b>{formatDate(selectedSchedule.startingDate)}</b>
              </label>
            )}
          </div>

          <Table
            // objectId={this.handleDeleteData.bind(this)}
            refetch={this.refetchData.bind(this)}
            // progress={loading}
            fields={schema.fields}
            objects={selectedSchedule?.scheduleArray}
            collection={schema}
            count={count}
            limit={limit}
            current={current}
            loadPagination={this.onClickPagination.bind(this)}
            // actionsList={[
            //   {
            //     label: <i className="bi bi-trash" />,
            //     actionType: "delete",
            //   },
            // ]}
            excludeFields={Object.keys(schema.fields).reduce(
              (acc, key) => {
                const options = schema.fields[key];
                if (options.read === false) {
                  acc.push(key);
                }
                switch (options._type || options.type) {
                  case "Relation":
                  case "Array":
                  case "Object":
                  case "File":
                    acc.push(key);
                    break;
                  default:
                }
                return acc;
              },
              ["id", "Created At", "Updated At", "name"],
            )}
            onClickItem={this.onClickItem.bind(this)}
          />
        </div>
      </>
    );
  }
}
